import { AlgAttivazioniService } from './../../../../services/alg-attivazioni.service';
import { IModalDialog, IModalDialogOptions, IModalDialogButton, IModalDialogSettings } from 'ngx-modal-dialog';
import { Component, OnInit, ComponentRef } from '@angular/core';
import { UtilsService } from '../../../../services/utils.service';

@Component({
  selector: 'alg-attivazioni-stop-modal',
  templateUrl: './alg-attivazioni-stop-modal.component.html',
  styleUrls: ['./alg-attivazioni-stop-modal.component.scss']
})
export class AlgAttivazioniStopModalComponent implements OnInit, IModalDialog {

  public attivazione: any;
  actionButtons: IModalDialogButton[];
  actionSettings: IModalDialogSettings[];
  
  constructor(
    private api: AlgAttivazioniService, 
    private utils: UtilsService
  ) { 
    this.actionButtons = [
      { text: '', buttonClass: 'alg-btn-close',  onAction: () => {
        this.utils.abilityOverflow();
        return true;
      }}, // no special processing here
      { text: 'Chiudi', buttonClass: 'button-full-close', onAction: () => {
          this.utils.abilityOverflow();
          return true;
      }}
    ];
  }

  ngOnInit() {
    this.api.attivazione$.subscribe((attivazione) => {      
      this.attivazione = attivazione;
    });
  }

  dialogInit(reference: ComponentRef<IModalDialog>, options: Partial<IModalDialogOptions<string>>) {}

}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/dialogs/alg-attivazioni-stop-modal/alg-attivazioni-stop-modal.component.ts